// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunk." + chunkId + "." + "38f4191ceea15cd6450d" + ".css";
};